import { createFileRoute } from '@tanstack/react-router';
import FleetTable from '@/featured/dashboard/fleets';

export default function Fleets() {
  return (
    <div className="w-full">
      <FleetTable />
    </div>
  );
}

export const Route = createFileRoute('/_authenticated/dashboard/fleets')({
  component: Fleets,
});
